import { i as initialize } from './ionic-global-e0b8d325.js';

const globalScripts = initialize;

export { globalScripts as g };
